module.exports = __webpack_public_path__ + "img/icon-arrow-left.9c6ff74e.svg";